/**
 * @generated SignedSource<<d0386c17adf4898b99b849442634802b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SalesforceInstanceType = "NOTE" | "TASK";
import { FragmentRefs } from "relay-runtime";
export type SalesforceIntegration_viewer$data = {
  readonly account: {
    readonly billingAccount: {
      readonly hasAccessToSalesforceFeature: boolean;
    };
    readonly integrations: {
      readonly hubspot: {
        readonly userConnected: boolean;
      } | null;
      readonly salesforce: {
        readonly configurer: {
          readonly id: string;
        } | null;
      } | null;
    };
  };
  readonly hasAccessToCopilot: boolean;
  readonly integrations: {
    readonly hubspot: {
      readonly isConnected: boolean;
    } | null;
    readonly salesforce: {
      readonly autoSendNotesEnabled: boolean;
      readonly createInSalesforceAs: SalesforceInstanceType;
      readonly includeRecapInAutoSendNotes: boolean;
      readonly isConnected: boolean;
      readonly relateToAccount: boolean;
      readonly relateToOpportunity: boolean;
    } | null;
  };
  readonly " $fragmentType": "SalesforceIntegration_viewer";
};
export type SalesforceIntegration_viewer$key = {
  readonly " $data"?: SalesforceIntegration_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SalesforceIntegration_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SalesforceIntegration_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAccessToCopilot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": "hasAccessToSalesforceFeature",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "salesforce_integration"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"salesforce_integration\")"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountIntegrations",
          "kind": "LinkedField",
          "name": "integrations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "HubspotAccountNode",
              "kind": "LinkedField",
              "name": "hubspot",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userConnected",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SalesforceWorkspaceConfigurationNode",
              "kind": "LinkedField",
              "name": "salesforce",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "configurer",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserIntegrations",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SalesforceUserNode",
          "kind": "LinkedField",
          "name": "salesforce",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "autoSendNotesEnabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "includeRecapInAutoSendNotes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createInSalesforceAs",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "relateToOpportunity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "relateToAccount",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "HubspotUserNode",
          "kind": "LinkedField",
          "name": "hubspot",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "3219fcb1a3f8d141d8d9df12255aa282";

export default node;
